import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async () => {
    const { data } = await ApiService.getDspProductCategories();
    return data;
};

const useDspProductCategoryListQuery = () => {
    return useQuery({
        queryKey: ['dspProductCategoryList'],
        queryFn: () => fetchData(),
        staleTime: Infinity,
        enabled: false,
    });
};

export { useDspProductCategoryListQuery };
